import getConfig from 'next/config';

/**
 * Next.jsの環境設定からURLプレフィックスを付与したパスを生成する
 * デプロイ環境ごとに異なるURLプレフィックスを透過的に扱うために使用する。
 * リダイレクトやリンク生成時にこの関数を通してパスを計算することで、
 * 環境差分を意識する必要がなくなる。
 *
 * @param path ベースパス（例: '/login'）
 * @returns URLプレフィックス付きのフルパス
 */
const url = (path: string): string => {
  const { publicRuntimeConfig } = getConfig() as {
    publicRuntimeConfig: { urlPrefix: string };
  };
  return publicRuntimeConfig.urlPrefix + path;
};

export default url;
